import { render, staticRenderFns } from "./tableTwo.vue?vue&type=template&id=2ffc81cb&scoped=true&"
import script from "./tableTwo.vue?vue&type=script&lang=js&"
export * from "./tableTwo.vue?vue&type=script&lang=js&"
import style0 from "./tableTwo.vue?vue&type=style&index=0&id=2ffc81cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffc81cb",
  null
  
)

export default component.exports